import { useFormik } from 'formik';
import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Input, Loader, Text } from 'rizzui';
import { toast } from 'sonner';
import fullLogo from '../../assets/logo_completo.png';
import { RootState } from '../../redux/store';
import { LoginService } from '../../services/auth/loginService';
import CustomCard from '../../components/card/CustomCard';
import backgroundImage from '../../assets/images/truck_backgorund.jpg';

const ForgotPassword: FC = () => {

    // STATES 

    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated } = useSelector((state: RootState) => state.auth);

    // HOOKS

    const navigate = useNavigate();


    if (isAuthenticated) {
        setTimeout(() => {
            navigate('/users', { replace: true })
        }, 100);
    }

    // FUNCTIONS

    // ----------------------------------------------------------------------------------------------------------------
    /**
     * @ES ENVIA EL EMAIL DE RECUPERACION DE CONTRASEÑA
     * @EN SENDS THE EMAIL FORGOT PASSWORD
     * 
     * @param username 
     */
    // ----------------------------------------------------------------------------------------------------------------
    const handleEmailForgotPassword = async (username: string) => {
        setIsLoading(true);
        const response = await (await (new LoginService()).sendEmailForgotPassword(username)).getResponseData();

        if (!response.success) {
            toast.error(response.message);
            setIsLoading(false);
            return;
        }

        if (response.success) {
            try {
                navigate('/login', { replace: true });
                toast.success('Email enviado. Por favor revise su correo.');
            } catch (error) {
                toast.error('Error sending email. Please try again later.');
                return;
            } finally {
                setIsLoading(false);
            }
        }
    };
    // ----------------------------------------------------------------------------------------------------------------

    // FORMIK

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: { loginUsername: '' },
        validate: (values) => {
            const errors: { loginUsername?: string; loginPassword?: string } = {};
            if (!values.loginUsername) {
                errors.loginUsername = 'Requerido';
            }
            return errors;
        },
        validateOnChange: false,
        onSubmit: (values) => { handleEmailForgotPassword(values.loginUsername) },
    });

    // RENDER

    return (
        <div className="relative min-h-screen flex items-center justify-center bg-black">
            <img src={backgroundImage} alt="Fondo" className="absolute inset-0 w-full h-full object-cover brightness-25 blur-sm z-0" />
            <div className="absolute top-0 right-0 w-full flex justify-center md:justify-start p-6 z-20">
                <img src={fullLogo} alt="Logo de Gema" className="w-32 md:w-40" />
            </div>
            <div className="relative z-10 w-full login-shadow max-w-md bg-white rounded-lg shadow-lg p-8 flex flex-col items-center mt-20 md:mt-0">
                <div className='text-center mb-1'>
                    <Text className="text-2xl font-bold text-black mt-5 mb-3">¿Has olvidado tu contraseña?</Text>
                    <Text className="text-sm text-gray-800">Introduce tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.</Text>
                </div>
                <form onSubmit={formik.handleSubmit} className="w-full flex flex-col gap-5 border-0">
                    <CustomCard title="Cambiar Contraseña" className="bg-transparent shadow-none p-0 border-0">
                        <div className="space-y-5">
                            <Input
                                id='loginUsername'
                                type="email"
                                size="lg"
                                label="Email de recuperación"
                                placeholder="Introducte tu email"
                                labelClassName='text-base font-medium text-black'
                                className="[&>label>span]:font-medium text-black"
                                inputClassName="text-sm border border-black/70 rounded-md"
                                onChange={formik.handleChange}
                                error={formik.errors.loginUsername}
                            />
                            <Button className="w-full bg-primary text-white hover:bg-primary/90" type="submit" size="lg" disabled={isLoading}>
                                {isLoading ? <Loader /> : 'Enviar email de recuperación'}
                            </Button>
                            <div className="flex items-center justify-between mt-1 mb-1 w-full">
                                <Link to="/login" className="text-sm text-primary transition-colors hover:text-primary/70 font-bold">Volver a Iniciar sesión</Link>
                            </div>
                        </div>
                    </CustomCard>
                </form>
            </div>
        </div>
    );
};

export default ForgotPassword;